import React from 'react';
import { Switch, Route } from 'react-router-dom';

// Components
import { Layout, AdminLayout } from './ParentLayout.imports-loadable';

function ParentLayout() {
  return (
    <div>
      <Switch>
        <Route path='/admin' component={AdminLayout} />
        <Route exact path='/vendor/register' component={Layout} />
        <Route path='/vendor' component={AdminLayout} />
        <Route exact path='/catering/register' component={Layout} />
        <Route exact path='/catering' component={Layout} />
        <Route path='/catering' component={AdminLayout} />
        <Route exact path='/account' component={AdminLayout} />
        <Route exact path='/welcome' component={AdminLayout} />
        <Route exact path='/forgot-password' component={Layout} />
        <Route exact path='/change-password' component={AdminLayout} />
        <Route path='/' component={Layout} />
      </Switch>
    </div>
  );
}

export default ParentLayout;
